import { render, staticRenderFns } from "./MyVideo.vue?vue&type=template&id=457b5687&scoped=true&"
import script from "./MyVideo.vue?vue&type=script&lang=js&"
export * from "./MyVideo.vue?vue&type=script&lang=js&"
import style0 from "./MyVideo.vue?vue&type=style&index=0&id=457b5687&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457b5687",
  null
  
)

export default component.exports